"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLayers = updateLayers;
const either_1 = require("../../types/either");
const layers_1 = require("../layers");
const designs_1 = require("../designs");
/**
 * Updates the printable layers in place
 */
function updateLayers(_ref) {
  let {
    sku,
    printable,
    printableRotatedInWorkspace,
    oldSurface,
    newSurface,
    newTemplate,
    leftDesign,
    rightDesign,
    printableGroupType,
    ignoreEditableTextTemplateLayers
  } = _ref;
  switch (printableGroupType) {
    case 'wooden-box':
      return handleWoodenBoxLayersUpdate({
        printable,
        printableRotatedInWorkspace,
        oldSurface,
        newSurface,
        newTemplate
      });
    default:
      return handleLayersUpdate({
        sku,
        printable,
        printableRotatedInWorkspace,
        oldSurface,
        newSurface,
        newTemplate,
        leftDesign,
        rightDesign,
        printableGroupType,
        ignoreEditableTextTemplateLayers
      });
  }
}
function handleWoodenBoxLayersUpdate(_ref2) {
  let {
    printable,
    printableRotatedInWorkspace,
    oldSurface,
    newSurface,
    newTemplate
  } = _ref2;
  var _a;
  const woodenBoxLayers = (_a = newTemplate.woodenBox) === null || _a === void 0 ? void 0 : _a.layers;
  if (!woodenBoxLayers) {
    return (0, either_1.left)(new Error('Could not update wooden-box printable: No wooden box layers found in template'));
  }
  printable.layers = (0, layers_1.updatePrintableDesignLayers)({
    oldSurface,
    newSurface,
    workspaceRotatedForPrintable: printableRotatedInWorkspace,
    existingPrintableLayers: printable.layers,
    newTemplateLayers: woodenBoxLayers,
    ignoreEditableTextTemplateLayers: false
  });
  return (0, either_1.right)(undefined);
}
function handleLayersUpdate(_ref3) {
  let {
    sku,
    printable,
    printableRotatedInWorkspace,
    oldSurface,
    newSurface,
    newTemplate,
    leftDesign,
    rightDesign,
    printableGroupType,
    ignoreEditableTextTemplateLayers
  } = _ref3;
  const getLayersForDesignResult = (0, designs_1.getLayersForDesign)(sku, newTemplate, leftDesign, rightDesign);
  if (getLayersForDesignResult.isLeft()) {
    return (0, either_1.left)(getLayersForDesignResult.value);
  }
  printable.layers = (0, layers_1.updatePrintableDesignLayers)({
    oldSurface,
    newSurface,
    workspaceRotatedForPrintable: printableRotatedInWorkspace,
    existingPrintableLayers: printable.layers,
    newTemplateLayers: getLayersForDesignResult.value,
    ignoreEditableTextTemplateLayers: printableGroupType === 'interior' && ignoreEditableTextTemplateLayers,
    shouldCopyExistingUserPhotoLayers: !newTemplate.shouldReplaceLayersWithNewTemplateDesign && printableGroupType === 'interior'
  });
  return (0, either_1.right)(undefined);
}